import { render, staticRenderFns } from "./DamagedDialog.vue?vue&type=template&id=21783c5e&scoped=true"
import script from "./DamagedDialog.vue?vue&type=script&lang=js"
export * from "./DamagedDialog.vue?vue&type=script&lang=js"
import style0 from "./DamagedDialog.vue?vue&type=style&index=0&id=21783c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21783c5e",
  null
  
)

export default component.exports